module.exports = __webpack_public_path__ + "img/portrait-036.844b2d21.jpg";